import { produce } from 'immer';
import { GET_THEORIES_START, GET_THEORIES_SUCCESS, GET_THEORIES_ERROR } from '../actions/homework';
import { parseTheories } from './../lib/utils';

export const initialState = {
    theories: [],
    status: {
        fetching: false,
    },
};

export const reducer = produce((state = initialState, action = {}) => {
    switch (action.type) {
        case GET_THEORIES_START:
            return {
                ...state,
                status: {
                    fetching: true,
                },
            };
        case GET_THEORIES_SUCCESS: {
            const exerciseTheories = parseTheories(action.payload.data);

            return {
                ...state,
                theories: [...state.theories, { id: action.payload.id, data: exerciseTheories }],
                status: {
                    fetching: false,
                },
            };
        }
        case GET_THEORIES_ERROR:
            return {
                ...state,
                theories: [...state.theories, { id: action.payload.id, data: [] }],
                status: {
                    fetching: false,
                },
            };
        default:
            return state;
    }
});
